var map = {
	"./blackGold/main/trashBinLogo.png": 13470,
	"./brownGold/main/trashBinLogo.png": 60425,
	"./darkBlue/main/trashBinLogo.png": 65363,
	"./greenYellow/main/trashBinLogo.png": 29109,
	"./redGold/main/trashBinLogo.png": 95117,
	"./skyBlue/main/trashBinLogo.png": 95376,
	"./whiteGold/main/trashBinLogo.png": 69761,
	"./yellowWhite/main/trashBinLogo.png": 18621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63556;